/* Numbers the way people say them, and dates the way they read them. */

export function compact(n: number | null | undefined): string {
  if (n === null || n === undefined || !Number.isFinite(n)) return "";
  const abs = Math.abs(n);
  if (abs >= 1_000_000_000) return `${(n / 1_000_000_000).toFixed(1).replace(/\.0$/, "")}B`;
  if (abs >= 1_000_000) return `${(n / 1_000_000).toFixed(1).replace(/\.0$/, "")}M`;
  if (abs >= 10_000) return `${Math.round(n / 1_000)}k`;
  if (abs >= 1_000) return `${(n / 1_000).toFixed(1).replace(/\.0$/, "")}k`;
  return String(Math.round(n));
}

export function money(usd: number | null | undefined): string {
  if (usd === null || usd === undefined) return "";
  if (usd === 0) return "$0";
  if (usd < 0.01) return "under 1¢";
  return usd < 10 ? `$${usd.toFixed(2)}` : `$${Math.round(usd).toLocaleString()}`;
}

export function multiple(x: number | null | undefined): string {
  if (x === null || x === undefined) return "";
  return x >= 10 ? `${Math.round(x)}x` : `${x.toFixed(1)}x`;
}

const rtf = new Intl.RelativeTimeFormat(undefined, { numeric: "auto" });

export function ago(iso: string | Date | null | undefined, now = Date.now()): string {
  if (!iso) return "";
  const seconds = (new Date(iso).getTime() - now) / 1000;
  const abs = Math.abs(seconds);
  if (abs < 60) return "just now";
  if (abs < 3600) return rtf.format(Math.round(seconds / 60), "minute");
  if (abs < 86400) return rtf.format(Math.round(seconds / 3600), "hour");
  if (abs < 86400 * 30) return rtf.format(Math.round(seconds / 86400), "day");
  return new Date(iso).toLocaleDateString(undefined, { day: "numeric", month: "short" });
}

/** "2026-09-28" as "Sunday 28 September", or "Today". */
export function dayLabel(day: string, today = new Date()): string {
  const date = new Date(`${day}T12:00:00`);
  const todayIso = today.toLocaleDateString("en-CA");
  if (day === todayIso) return "Today";
  const yesterday = new Date(today.getTime() - 86_400_000).toLocaleDateString("en-CA");
  if (day === yesterday) return "Yesterday";
  return date.toLocaleDateString(undefined, { weekday: "long", day: "numeric", month: "long" });
}

export function shiftDay(day: string, by: number): string {
  const date = new Date(`${day}T12:00:00`);
  date.setDate(date.getDate() + by);
  return date.toLocaleDateString("en-CA");
}
